import axios from "axios";
import { toast } from "sonner";
import { API } from "../App";

export const DEFAULT_RECORDING_SETTINGS = { reminder_minutes: 60, repeat_minutes: 15, pre_session_minutes: 5, push_before_session: true };

export const fetchRecordingSettings = async () => {
  try { return { ...DEFAULT_RECORDING_SETTINGS, ...(await axios.get(`${API}/therapist/recording-settings`, { withCredentials: true })).data }; }
  catch { return DEFAULT_RECORDING_SETTINGS; }
};

const beep = () => {
  try {
    const Ctx = window.AudioContext || window.webkitAudioContext;
    if (!Ctx) return;
    const ctx = new Ctx();
    [0, 0.25].forEach((t) => {
      const o = ctx.createOscillator(); const g = ctx.createGain();
      o.type = "sine"; o.frequency.value = 880; g.gain.value = 0.08;
      o.connect(g); g.connect(ctx.destination);
      o.start(ctx.currentTime + t); o.stop(ctx.currentTime + t + 0.15);
    });
    setTimeout(() => ctx.close(), 1000);
  } catch { /* audio indisponible */ }
};

const systemNotify = async (title, body) => {
  if (typeof Notification === "undefined" || Notification.permission !== "granted") return;
  try {
    const reg = await navigator.serviceWorker?.getRegistration();
    if (reg) await reg.showNotification(title, { body, icon: "/logo192.png", tag: "kintsugi-recording-reminder", renotify: true });
    else new Notification(title, { body });
  } catch { /* ignore */ }
};

export const fmtDuration = (sec) => { const h = Math.floor(sec / 3600), m = Math.floor((sec % 3600) / 60); return h ? `${h} h ${String(m).padStart(2, "0")}` : `${m} min`; };

// Rappel « séance longue » : alerte in-app (toast persistant + vibration + son + notification système) à reminder_minutes puis toutes les repeat_minutes.
export const fireLongRecordingReminder = (elapsedSec, label, onStop) => {
  const title = `Enregistrement en cours depuis ${fmtDuration(elapsedSec)}`;
  const body = `${label} — pensez à arrêter et transcrire la séance.`;
  navigator.vibrate?.([200, 100, 200, 100, 400]);
  beep();
  systemNotify(title, body);
  toast.warning(title, { id: "recording-reminder", description: body, duration: 60000, action: { label: "Arrêter", onClick: onStop } });
};
